import { InquiryPeriod } from "../../store/inquiries/types";
import usePeriods from "../common/usePeriods";

export default function useLuomumaitotuotteidenValmistusPeriods(): InquiryPeriod[] {
  return usePeriods("luomumaitotuotteiden-valmistus");
}
